/**
 * Profile Menu Action Item IDs
 * Used to identify menu items in the profile menu actions
 */
export const PROFILE_MENU_ACTION_IDS = {
  FOLLOW: 'follow',
  COPY_PUBKY: 'copy-pubky',
  COPY_LINK: 'copy-link',
  MUTE: 'mute',
} as const;
